import React, {
  FormEvent,
  DetailedHTMLProps,
  InputHTMLAttributes,
} from "react";

type TextFieldProps = {
  id: string;
  placeholder?: string;
  type?: string;
  full?: boolean;
  className?: string;
  onChange?: any;
  value?: any;
  [key: string]: any;
};
const TextField: React.FC<TextFieldProps> = (props): React.ReactElement => {
  const { type, full, className, ...rest } = props;

  return (
    <input
      autoComplete="off"
      type={type ? type : "text"}
      className={`${
        full ? "w-full" : "w-full md:w-8/12"
      } focus:outline-none border-2 border-grey rounded-md h-14 p-3 text-blueishblack font-bold text-base ${
        className ? className : ""
      }`}
      {...rest}
    />
  );
};

export default TextField;
